export default __webpack_public_path__ + "static/media/BlazeSky.826bc35b.png";